/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { Modal } from 'bootstrap';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  clientId: string | null | undefined;
  openedDialogArray: any[] = [];
  isScannerVisible = false;
  showCoinGlowEffect = false;
  title: string | undefined;
  message: string | undefined;
  private dialogSubject = new Subject<boolean>();

  constructor() {}

  openError(title: string, message: string) {
    this.closeDialog();
    this.title = title;
    this.message = message;
    this.openDialog('staticErrorBackdrop');
  }

  openAnimationDialog(
    title: string | undefined,
    message: string,
    isScannerVisible: boolean,
    showCoinGlowEffect = false
  ) {
    this.closeDialog();
    this.title = title;
    this.message = message;
    this.isScannerVisible = isScannerVisible;
    this.showCoinGlowEffect = showCoinGlowEffect;
    this.openDialog('staticAnimationBackdrop');
  }

  openConfirmation(title: string | undefined, message: string, showCoinGlowEffect = false) {
    this.closeDialog();
    this.title = title;
    this.message = message;
    this.showCoinGlowEffect = showCoinGlowEffect;
    this.openDialog('staticConfirmBackdrop');
  }

  openTerms() {
    this.closeDialog();
    this.openDialog('staticTermsBackdrop');
  }

  openPrivacy() {
    this.closeDialog();
    this.openDialog('staticPrivacyBackdrop');
  }

  openChangePasswordModal(title: string | undefined, message: string) {
    this.closeDialog();
    this.title = title;
    this.message = message;
    this.openDialog('staticChangePasswordBackdrop');
  }

  openYesNoDialog(title: string | undefined, message: string): Observable<boolean> {
    this.closeDialog();
    this.title = title;
    this.message = message;
    this.dialogSubject = new Subject<boolean>(); // Create a new subject instance
    this.openDialog('staticYesNoBackdrop');

    return this.dialogSubject.asObservable();
  }

  confirmYes() {
    if (this.dialogSubject) {
      this.dialogSubject.next(true);
      this.dialogSubject.complete(); // Complete only after emission
    }
  }

  openVoucherDialog(title: string, message: string, showCoinGlowEffect = false) {
    this.closeDialog();
    this.showCoinGlowEffect = showCoinGlowEffect;
    this.title = title;
    this.message = message;
    this.openDialog('staticVoucherBackdrop');
  }

  openNotificationDialog() {
    this.closeDialog();
    this.openDialog('staticNotificationBackdrop');
  }

  cancelNo() {
    if (this.dialogSubject) {
      this.dialogSubject.next(false);
      this.dialogSubject.complete(); // Complete only after emission
    }
  }

  closeDialog() {
    if (this.openedDialogArray.length === 0) {
      return;
    }
    this.openedDialogArray.forEach(function (openedDialog) {
      openedDialog.hide();
    });
    this.isScannerVisible = false;
    if (this.showCoinGlowEffect) {
      this.showCoinGlowCssEffect();
    }
  }

  private showCoinGlowCssEffect() {
    const coinBalanceDiv = document.getElementById('coinBalanceDiv');
    const coinsBalanceText = document.getElementById('coinsBalanceText');
    coinBalanceDiv?.classList.add('resize');
    coinsBalanceText?.classList.add('resize-font');
    setTimeout(() => {
      coinBalanceDiv?.classList.remove('resize');
      coinsBalanceText?.classList.remove('resize-font');
      this.showCoinGlowEffect = false;
    }, 3000);
  }

  private openDialog(dialogId: string) {
    const myModal = new Modal(document.getElementById(dialogId)!);
    this.openedDialogArray.push(myModal);
    myModal.show();
  }
}
